__turbopack_context__.v({
  "article": "ArticleCard-module-scss-module__EOerXG__article",
  "articleLarge": "ArticleCard-module-scss-module__EOerXG__articleLarge",
  "articleMedium": "ArticleCard-module-scss-module__EOerXG__articleMedium",
  "articleSmall": "ArticleCard-module-scss-module__EOerXG__articleSmall",
  "badges": "ArticleCard-module-scss-module__EOerXG__badges",
  "body": "ArticleCard-module-scss-module__EOerXG__body",
  "excerpt": "ArticleCard-module-scss-module__EOerXG__excerpt",
  "fade-in": "ArticleCard-module-scss-module__EOerXG__fade-in",
  "footer": "ArticleCard-module-scss-module__EOerXG__footer",
  "icon": "ArticleCard-module-scss-module__EOerXG__icon",
  "image": "ArticleCard-module-scss-module__EOerXG__image",
  "link": "ArticleCard-module-scss-module__EOerXG__link",
  "meta": "ArticleCard-module-scss-module__EOerXG__meta",
  "no-transform": "ArticleCard-module-scss-module__EOerXG__no-transform",
  "preTitle": "ArticleCard-module-scss-module__EOerXG__preTitle",
  "rotate": "ArticleCard-module-scss-module__EOerXG__rotate",
  "title": "ArticleCard-module-scss-module__EOerXG__title",
});
